import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { EXPERIMENTS_ERROR, EXPERIMENTS_LOADED, EXPERIMENTS_LOADING } from 'redux/actionTypes/experiments';
var loadExperiments = function loadExperiments() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var experiments, errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: EXPERIMENTS_LOADING
            });
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI('/v2/experiments');
          case 4:
            experiments = _context.sent;
            experiments.forEach(function (experiment) {
              // eslint-disable-next-line no-param-reassign
              experiment.sampleIds = experiment.samplesOrder;
              // eslint-disable-next-line no-param-reassign
              delete experiment.samplesOrder;
            });
            dispatch({
              type: EXPERIMENTS_LOADED,
              payload: {
                experiments: experiments
              }
            });
            _context.next = 13;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](1);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_LOADING_PROJECT);
            dispatch({
              type: EXPERIMENTS_ERROR,
              payload: {
                error: errorMessage
              }
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 9]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadExperiments;